import React from 'react'
import './still.css'


const İndex = () => {
  return (
    <div className='headerContainer'>
    </div>
  )
}

export default İndex